import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import IntroSection from "@/components/landing/IntroSection";
import Marquee from "@/components/landing/Marquee";
import ServicesBento from "@/components/landing/ServicesBento";
import StatsSection from "@/components/landing/StatsSection";
import ClientsCarousel from "@/components/landing/ClientsCarousel";
import ProjectsGallery from "@/components/landing/ProjectsGallery";
import SmartHomesSection from "@/components/landing/SmartHomesSection";
import CTABanner from "@/components/landing/CTABanner";
import ContactSection from "@/components/landing/ContactSection";
import Footer from "@/components/landing/Footer";
import AIChatbot from "@/components/chat/AIChatbot";
import WhatsAppButton from "@/components/landing/WhatsAppButton";

export default function LandingPage() {
  return (
    <div className="relative bg-white" data-testid="landing-page">
      <Navbar />
      <Hero />
      <IntroSection />
      <Marquee />
      <ServicesBento />
      <StatsSection />
      <ClientsCarousel />
      <ProjectsGallery />
      <SmartHomesSection />
      <CTABanner />
      <ContactSection />
      <Footer />
      <AIChatbot />
      <WhatsAppButton />
    </div>
  );
}
